export default __webpack_public_path__ + "static/media/package-a.8d745c9e.jpg";